<!--
* Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
* This software is released under MIT license.
* The full license information can be found in LICENSE in the root directory of this project.
-->

<clr-monthpicker *ngIf="isMonthView"></clr-monthpicker>
<clr-yearpicker *ngIf="isYearView"></clr-yearpicker>
<clr-daypicker *ngIf="isDayView"></clr-daypicker>
